import { useHover } from "designSystem/hooks";
import { MenuItem, MoreHorizMenu } from "designSystem/index";
import { preventDefaultBehaviour } from "designSystem/utilities/prevent-default-behavior";
import { observer } from "mobx-react-lite";
import React, { FC, RefObject, forwardRef } from "react";
import DeleteButton from "../DeleteButton";
import { CustomViewItem } from "./CustomViewItem";

export interface CustomViewItemActionMenuProps {
	/** custom view item */
	customViewItem: CustomViewItem;
}

const CustomViewItemActionMenu: FC<CustomViewItemActionMenuProps> = observer(forwardRef((props: CustomViewItemActionMenuProps, ref: RefObject<HTMLElement>) => {
	const { customViewItem } = props;
	const hovering = useHover(ref);

	const {
		addToFavorite,
		discard,
		duplicate,
		enableSaveButton,
		hideDeleteButton,
		onOpenMenu,
		removeFromFavorites,
		save,
		saveAs,
		showAddToFavorite,
		showDiscard,
		showDuplicate,
		showRemoveFromFavorite,
		showSaveAs,
	} = customViewItem;

	return (
		<MoreHorizMenu
			hovering={hovering}
			onClose={preventDefaultBehaviour}
			onOpen={onOpenMenu}
			showOnHover
			sx={{ height: 14 }}
		>
			{showAddToFavorite && (
				<MenuItem
					onClick={addToFavorite}
					res="CustomViewFavoritesAdd"
				/>
			)}
			{showRemoveFromFavorite && (
				<MenuItem
					onClick={removeFromFavorites}
					res="CustomViewFavoritesRemove"
				/>
			)}
			<MenuItem
				disabled={!enableSaveButton}
				onClick={save}
				res="CustomViewSave"
			/>
			{showDiscard && (
				<MenuItem
					onClick={discard}
					res="BUTTON_DISCARD"
				/>
			)}
			{showSaveAs && (
				<MenuItem
					onClick={saveAs}
					res="CustomViewSaveAs"
				/>
			)}
			{showDuplicate && (
				<MenuItem
					onClick={duplicate}
					res="CustomViewDuplicate"
				/>
			)}
			{!hideDeleteButton &&
				<DeleteButton customViewItem={customViewItem} />
			}
		</MoreHorizMenu>
	);
}));

export default CustomViewItemActionMenu;